<app-sidenav-v2
[shortMenu]="true">
<div class="container">
    <div class="box">
        <app-nuevo-flujo *ngIf="new_flow"></app-nuevo-flujo>

    </div>
    <app-socials-footer style="width: 100%;"></app-socials-footer>
</div>
</app-sidenav-v2>